import { forwardRef, useEffect, createElement } from 'react';
import { useProxiedRef } from '../../../utils/hooks/useProxiedRef.js';
import { useCurrentMenu } from '../Context.js';
import { Trigger as Trigger$1 } from '@radix-ui/react-dropdown-menu';

const Trigger = /*#__PURE__*/forwardRef(function MenuTrigger(props, ref) {
  const menu = useCurrentMenu();
  const internalRef = useProxiedRef(ref);
  useEffect(() => {
    if (internalRef.current) {
      menu === null || menu === void 0 ? void 0 : menu.setMinWidth(internalRef.current.getBoundingClientRect().width);
    }
  }, [internalRef]);
  return createElement(Trigger$1, Object.assign({}, props, {
    asChild: true,
    ref: internalRef
  }));
});

export { Trigger };
//# sourceMappingURL=Trigger.js.map
